module.exports = __webpack_public_path__ + "img/banner.70274af4.png";